import React, {useEffect, useState} from 'react';
import "./CreateAccountMailing.scss";
import FCSelect from "../../../components/FCObjets/Form/FCSelect";

export interface InterfaceCreateAccountMailing {
    serverSMTP: string;
    userSmtp: string;
    passSMTP: string;
}

export type CreateAccountMailingProps = {
    handlerChange: (dataMailing: InterfaceCreateAccountMailing) => void;
};

const CreateAccountMailing: React.FC<CreateAccountMailingProps> = (props: CreateAccountMailingProps) => {

    const [dataMailing, setDataMailing] = useState<InterfaceCreateAccountMailing>({
        passSMTP: "",
        serverSMTP: "",
        userSmtp: ""
    });
    const [showPass, setShowPass] = useState(false);

    const optionsServer = [
        {value: "", label: "Sélectionnez un fournisseur…"},
        {value: "HOTMAIL", label: "Hotmail"},
        {value: "GMAIL", label: "Gmail"},
    ];

    useEffect(() => {
        eventChange("serverSMTP", "HOTMAIL");
    }, []);

    const eventChange = (key: keyof InterfaceCreateAccountMailing, value: string) => {
        const v: InterfaceCreateAccountMailing = {...dataMailing, [key]: value};
        setDataMailing(v);
        props.handlerChange(v);
    };

    return (
        <>
            <div className="caSectionHeader">
                <h1 className="caSectionTitle">Données de Mailing</h1>
                <p className="caSectionSubtitle">
                    Configurez votre serveur d'envoi pour transmettre vos factures et documents officiels
                    avec une touche professionnelle.
                </p>
            </div>

            <div className="caCard">
                <div className="caField caFieldFull">
                    <label>Fournisseur Email</label>
                    <FCSelect
                        options={optionsServer}
                        value={dataMailing.serverSMTP}
                        onChange={(v) => eventChange("serverSMTP", String(v))}
                        placeholder="Sélectionnez un fournisseur…"
                    />
                </div>

                <div className="caFormGrid" style={{marginTop: 20}}>
                    <div className="caField">
                        <label htmlFor="smtpUser">SMTP User</label>
                        <input id="smtpUser" type="text" placeholder="contact@votre-atelier.fr"
                               value={dataMailing.userSmtp}
                               onChange={(e) => eventChange("userSmtp", e.target.value)}/>
                    </div>

                    <div className="caField caPassField">
                        <label htmlFor="smtpPass">SMTP Password</label>
                        <div className="caPassWrap">
                            <input id="smtpPass"
                                   type={showPass ? "text" : "password"}
                                   placeholder="••••••••••••"
                                   value={dataMailing.passSMTP}
                                   onChange={(e) => eventChange("passSMTP", e.target.value)}/>
                            <button type="button" className="caPassToggle"
                                    onClick={() => setShowPass(v => !v)}
                                    tabIndex={-1}>
                                <span className="material-symbols-outlined">
                                    {showPass ? "visibility" : "visibility_off"}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="caInlineAlert">
                    <span className="material-symbols-outlined">info</span>
                    <span>
                        Vos identifiants SMTP sont stockés de manière sécurisée et chiffrée. Ils ne seront
                        utilisés que pour l'envoi automatique de vos documents administratifs.
                    </span>
                </div>
            </div>
        </>
    );
};

export default CreateAccountMailing;
